const ICON_BY_NAME = [
  { keys: ['بی پاسخ', 'بی‌پاسخ', 'phone-slash', 'no answer'], icon: 'fa-phone-slash' },
  { keys: ['تلفنی خروجی', 'تماس خروجی', 'outgoing'], icon: 'fa-phone' },
  { keys: ['تلفنی ورودی', 'تماس ورودی', 'incoming', 'phone-volume'], icon: 'fa-phone-volume' },
  { keys: ['آنلاین', 'online', 'video', 'جلسه آنلاین'], icon: 'fa-video' },
  { keys: ['حضوری', 'users'], icon: 'fa-users' },
  { keys: ['واتساپ', 'whatsapp'], icon: 'fa-whatsapp' },
  { keys: ['تلگرام', 'telegram'], icon: 'fa-telegram' },
  { keys: ['شبکه', 'واتساپ', 'تلگرام', 'social', 'comment-dots', 'پیام شبکه'], icon: 'fa-comment-dots' },
  { keys: ['پیامک', 'sms'], icon: 'fa-sms' },
  { keys: ['ایمیل', 'mail', 'envelope'], icon: 'fa-envelope' },
  { keys: ['پیشنهاد', 'invoice', 'قیمت'], icon: 'fa-file-invoice-dollar' },
  { keys: ['قرارداد', 'signature'], icon: 'fa-file-signature' },
  { keys: ['پرداخت', 'credit'], icon: 'fa-credit-card' },
  { keys: ['پشتیبانی', 'headset'], icon: 'fa-headset' },
  { keys: ['مستند', 'سند', 'file-alt'], icon: 'fa-file-alt' },
  { keys: ['فایل', 'file'], icon: 'fa-file' },
  { keys: ['تماس', 'تلفن', 'phone'], icon: 'fa-phone' },
];

export const DEFAULT_ACTIVITY_COLOR = '#1890ff';

export const NO_ANSWER_FOLLOW_UP_REMARK = 'با این کاربر تماس گرفتم پاسخ داده نشد';

const NO_ANSWER_KEYWORDS = ['بی پاسخ', 'بی‌پاسخ', 'phone-slash', 'no answer', 'پاسخ داده نشد'];

const pickFirst = (...values) => {
  for (const value of values) {
    if (value != null && String(value).trim() !== '') return value;
  }
  return undefined;
};

export const inferActivityIcon = (name = '') => {
  const normalized = String(name || '').trim().toLowerCase();
  if (!normalized) return 'fa-calendar-check';
  const row = ICON_BY_NAME.find((item) =>
    item.keys.some((key) => normalized.includes(String(key).toLowerCase())),
  );
  return row?.icon || 'fa-calendar-check';
};

export const isNoAnswerFollowUpActivity = (activity) => {
  if (!activity) return false;
  const haystack = `${activity.name || ''} ${activity.icon || ''}`.toLowerCase();
  return NO_ANSWER_KEYWORDS.some((keyword) => haystack.includes(keyword.toLowerCase()));
};

export const normalizeFollowUpActivity = (item = {}) => {
  if (!item || (item.id == null && !item.name && !item.activity_name)) return null;
  const name = item.name || item.activity_name || item.type || '--';
  const rawIcon = pickFirst(item.icon, item.fa_icon, item.activity_icon, item.icon_class);
  const rawColor = pickFirst(item.color, item.label_color);
  return {
    id: item.id,
    name,
    icon: rawIcon || inferActivityIcon(name),
    color: rawColor || DEFAULT_ACTIVITY_COLOR,
  };
};

export const normalizeFollowUpActivities = (list = []) =>
  (Array.isArray(list) ? list : []).map(normalizeFollowUpActivity).filter(Boolean);

/**
 * ادغام لیست فعالیت‌ها — رنگ و آیکون کاتالوگ قبلی حفظ می‌شود
 */
export const mergeFollowUpActivities = (existing = [], incoming = []) => {
  const byId = new Map();
  normalizeFollowUpActivities(existing).forEach((activity) => {
    byId.set(String(activity.id), activity);
  });

  (Array.isArray(incoming) ? incoming : []).forEach((raw) => {
    if (raw?.id == null) return;
    const id = String(raw.id);
    const prev = byId.get(id);
    byId.set(
      id,
      normalizeFollowUpActivity({
        id: raw.id,
        name: pickFirst(raw.name, raw.activity_name, prev?.name),
        icon: pickFirst(raw.icon, raw.fa_icon, raw.activity_icon, prev?.icon),
        color: pickFirst(raw.color, raw.label_color, prev?.color),
      }),
    );
  });

  return Array.from(byId.values());
};

export const resolveFollowUpActivity = (followUp, catalog = []) => {
  if (!followUp) return null;
  const activityId =
    followUp.follow_up_activity_id ??
    followUp.activity?.id ??
    followUp.follow_up_activity?.id;
  const embedded = followUp.activity || followUp.follow_up_activity;
  const fromCatalog = catalog.find((a) => String(a.id) === String(activityId));

  return normalizeFollowUpActivity({
    id: activityId ?? embedded?.id ?? fromCatalog?.id,
    name: pickFirst(embedded?.name, embedded?.activity_name, fromCatalog?.name),
    icon: pickFirst(
      fromCatalog?.icon,
      embedded?.icon,
      embedded?.fa_icon,
      embedded?.activity_icon,
    ),
    color: pickFirst(
      fromCatalog?.color,
      fromCatalog?.label_color,
      embedded?.color,
      embedded?.label_color,
    ),
  });
};
